import styled from 'styled-components/macro';
import StyledFlexContainer from './StyledFlexContainer';

const SkillImageContainer = styled(StyledFlexContainer)`
	justify-content: center;
	align-items: center;
	width: 90px;
	height: 90px;
	border-radius: 50%;
	background-color: rgb(237, 242, 248);

	&:hover {
		box-shadow: 0 0 25px ${({ theme }) => theme.color.skillImageContainerHover};
	}
	@media screen and (min-width: 2000px) {
		width: 150px;
		height: 150px;
	}
	@media screen and (max-width: 450px) {
		width: 70px;
		height: 70px;
	}
`;

export default SkillImageContainer;
